import {Injectable } from '@angular/core';
import {Subject ,Observable} from 'rxjs';
// import { Store } from '@src/store';
//import { securityActions } from '@src/store/reducers/securityReducer';
const APP_VERSION = window.__env.config.versionRM;
const USER = 'user_' + APP_VERSION;

@Injectable({ providedIn: 'root' })
export class SessionService {
    public AuthType:string;
    public UpdateActivity: Subject<any>;
    public UpdateActivitySubject$ : Observable<any>;
    public UpdatePresentage: Subject<any>;
    public UpdatePresentageSubject$ : Observable<any>;
    public changeComponent: Subject<any>;
    public changeComponentSubject$ : Observable<any>;
    constructor(){  
        this.UpdatePresentage = new Subject<any>();
        this.UpdatePresentageSubject$ = this.UpdatePresentage;
        this.UpdateActivity = new Subject<any>();
        this.UpdateActivitySubject$ = this.UpdateActivity;
        this.changeComponent = new Subject<any>();
        this.changeComponentSubject$ = this.changeComponent;
    }
    public get(key: string): any {
        const item = localStorage.getItem(key);
        try {
            return JSON.parse(item);
        } catch {
            return item;
        }
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string) {
        localStorage.removeItem(key);
    }

    public get user(): any {
        return JSON.parse(localStorage.getItem(USER));
    }
    
    // public navigateToLoginPage(){
    //     this.remove(`user_${window.__env.config.versionRM}`);
    //     this.store.dispatch({
    //         type: securityActions.LOGOUT,
    //         callback: () => this.$state.go('app.auth.login')
    //     });
    // }
    public updateActivity(data){
        this.UpdateActivity.next(data)
    }

    public updatePresentage(data){
        this.UpdatePresentage.next(data)
    }

    public changeRoute(data){
        this.changeComponent.next(data)
    }

    public set user(user: any) {
        localStorage.setItem(USER, JSON.stringify(user));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/session.service.ts